// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ae732610","732":"ee97759f","977":"45997c97"}[chunkId] + ".chunk.js";
};